import React from 'react';
import PropTypes from 'prop-types';
import {MonthlyTableTds, MonthlyTableThs} from "./MonthlyTableColumns";

/**
 * Debigo al funcionamiento del z-index y la fijación de ciertas áreas con la posición "sticky" hemos recurrido
 * a una solución a partir de un z-index base. Este z-index base se basa en el número de filas que se vayan a
 * renderizar. Según el área se aplicará un mayor o menor z-index final:
 *
 * - THs columnas fijas: zIndexBase + 10 (por encima de todas)
 * - THs columnas movibles: zIndexBase + 5
 * - TDs columnas fijas: zIndexBase - rowIndex
 * - TDs columnas movibles: auto (por debajo a todas)
 *
 * Asignar un z-index diferente a los TDs columnas fijas de cada fila permite que los menús de tipo dropdown no
 * aparezcan por debajo de las filas inferiores.
 *
 * Funcionamiento z-index: https://stackoverflow.com/questions/7490146/z-index-relative-or-absolute/7490187#7490187
 */
export default class MonthlyTable extends React.Component {

    render() {
        const {
            days,
            onChangeWorkCheckTypeAll,
            onSortByColumn,
            columnSortAsc,
            columnSortedSelected,
            workers,
            monthChecksByWorker,
            workCheckTypes,
            workCheckStates,
            onChangeWorkCheckType,
            showDocumentsOfWorker,
            fixedThs,
        } = this.props;

        const zIndexBase = workers.length;

        return (
            <div className="listeria">
                <table className="table listeria-table">
                    <thead>
                        <tr>
                            <MonthlyTableThs
                                columnSortAsc={columnSortAsc}
                                columnSortedSelected={columnSortedSelected}
                                onSortByColumn={onSortByColumn}
                                showDocumentsOfWorker={showDocumentsOfWorker}
                                workCheckTypes={workCheckTypes}
                                workCheckStates={workCheckStates}
                                showMultipleValidation={true}
                                onChangeWorkCheckTypeAll={onChangeWorkCheckTypeAll}
                                zIndex={zIndexBase + 10}
                                fixedThs={fixedThs}
                            />
                            {
                                days.map((day, i) => (
                                    <th
                                        key={i}
                                        className={`th-day ${day.is_work_day ? '' : 'weekend'}`}
                                        children={day.day_of_month}
                                        style={{zIndex: zIndexBase + 5}}
                                    />
                                ))
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            workers.map((worker, workerIndex) => {
                                return (
                                    <tr key={worker.id}>
                                        <MonthlyTableTds
                                            worker={worker}
                                            showDocumentsOfWorker={showDocumentsOfWorker}
                                            monthChecksByWorker={monthChecksByWorker}
                                            workCheckTypes={workCheckTypes}
                                            workCheckStates={workCheckStates}
                                            onChangeWorkCheckType={onChangeWorkCheckType}
                                            zIndex={zIndexBase - workerIndex}
                                        />
                                        {
                                            this.renderDaysWork(worker.id)
                                        }
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    }

    renderDaysWork(workerId) {
        const {dayChecksByWorker, days} = this.props;

        return days.map((day, i) => {
            const isWorkDay = !day.is_work_day;
            const isChecked = dayChecksByWorker[workerId] && dayChecksByWorker[workerId][day.day_of_month];
            const classes = `${isWorkDay ? 'weekend' : ''} ${isChecked ? 'checked-cell' : 'unchecked-cell'}`;

            return (
                <td key={i} className={classes}>
                    {
                        isChecked
                            ? <i className="material-icons">done</i>
                            : null
                    }
                </td>
            );
        });
    }

}

MonthlyTable.propTypes = {
    days: PropTypes.array,
    workers: PropTypes.array,
    dayChecksByWorker: PropTypes.any,
    monthChecksByWorker: PropTypes.any,
    workCheckTypes: PropTypes.array,
    workCheckStates: PropTypes.array,
    tableClass: PropTypes.string,
    showDocumentsOfWorker: PropTypes.bool,
    columnSortedSelected: PropTypes.string,
    columnSortAsc: PropTypes.object,
    onChangeWorkCheckType: PropTypes.func,
    onChangeWorkCheckTypeAll: PropTypes.func,
    onSortByColumn: PropTypes.func,
    fixedThs: PropTypes.bool,
};

MonthlyTable.defaultProps = {
    days: [],
    workers: [],
    dayChecksByWorker: {},
    monthChecksByWorker: {},
    workCheckTypes: [],
    workCheckStates: [],
    onChangeWorkCheckType: () => {
    },
    onChangeWorkCheckTypeAll: () => {
    },
    tableClass: '',
    columnSortedSelected: '',
    showDocumentsOfWorker: false,
    fixedThs: true,
};



// WEBPACK FOOTER //
// ./src/app/my-outsources/monthly/components/MonthlyTable.js